import {
  Box,
  Card,
  CardContent,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";

import moment from "moment";
import { Grid } from "@mui/material";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import { useWalletAmount } from "@/components/Elements/api/getWalletamount";
import { useLotteryList } from "../api/getLotteryList";
import { useInvestedCoins } from "../api/getInvestedCoins";
import yellowt from "@/assets/yellow-t.png";
import CurrencyFormat from "react-currency-format";
import MervIcon from "@/assets/mervIcon.svg";
import "./myLottery.css";
import Pagination from "rc-pagination";

export type Payment = {
  endDate: Date;
  endTime: Date;
  lotteryDrawDate: string;
  lotteryImage: string;
  claimStatus?: string;
  transactionId: string;
  LotteryName: string;
  ticketNumber: string;
  createdDate: string;
  amount: number;
  winAmount: string;
  surpriceAmt: number;
  lotteryStatus: string;
};

export const MyLottery = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const dataWallet = useWalletAmount({});
  const coins = useInvestedCoins({});
  const { data, isLoading, isError, isFetching }: any = useLotteryList({
    page,
    limit,
  });
  console.log(data, "data");
  const lotteryData = data?.data || [];
  const pageCount = data?.pagination?.totalPages || 0;
  const currentPage = data?.pagination?.currentPage || 0;
  const totalItems = data?.pagination?.totalItems || 0;
  console.log(pageCount , currentPage , totalItems , "abhay")
  const handlePageChange = async (newPage: number) => {
    setLoading(true);
    setPage(newPage);
    setLoading(false);
  };
  const [pagination, setPagination] = useState({
    pageIndex: page,
    pageSize: limit,
  });
  const Item = styled(Paper)(() => ({
    background: "transparent",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  }));

  var cardStyle = {
    display: "block",
    transitionDuration: "0.3s",
    height: "auto",
    background: "#050518",
    boxShadow: "0 0 10px #8264eeb3",
    borderRadius: "20px",
  };

  const tableHead = {
    LotteryName: "Lottery Name",
    ticketNumber: "Ticket Number",
    createdDate: "Created At",
    amount: "Ticket Price",
    winAmount: "Win Amount",
    surpriceAmt: "Free Ticket Amount",
    lotteryStatus: "Status",
  };
  const getStatusStyle = (status: string): React.CSSProperties => {
    switch (status) {
      case "Winner":
        return {
          color: "#95D23D",
          borderRadius: "4px",
          border: "1px solid rgba(149, 210, 61, 0.41)",
          backgroundColor: "rgba(149, 210, 61, 0.19)",
          padding: "4px",
          display: "inline-block",
        };
      case "Pending":
        return {
          color: "#FF9900",
          borderRadius: "4px",
          border: "1px solid rgba(231, 214, 61, 0.5)",
          backgroundColor: "rgba(231, 214, 61, 0.1)",
          padding: "4px",
          display: "inline-block",
        };
      default:
        return {
          color: "#FF4545",
          borderRadius: "4px",
          border: "1px solid rgba(255, 69, 69, 0.4)",
          backgroundColor: "rgba(255, 69, 69, 0.05)",
          padding: "4px",
          display: "inline-block",
        };
    }
  };
  const excludedColumns = ["ticketNumber", "createdDate"];
  const tableRows = (rowData: { key: Record<string, any>; index: number }) => {
    const { key, index } = rowData;
    const tableCell = Object.keys(tableHead);

    const columnData = tableCell.map((keyD, i) => {
      let cellStyle: React.CSSProperties = {};
      let value = key[keyD];
      if (keyD === "createdDate") {
        value = moment(value).format("DD/MM/YYYY");
      }
      const numericValue = parseFloat(value);
      if (
        !excludedColumns.includes(keyD) &&
        !isNaN(numericValue) &&
        numericValue !== 0
      ) {
        cellStyle.color = numericValue < 0 ? "red" : "green";
        cellStyle.fontWeight = "bold";
      }
      return (
        <td key={i} className="td" style={cellStyle}>
          {keyD === "lotteryStatus" ? (
            <span style={getStatusStyle(value)}>{value}</span>
          ) : (
            value
          )}
        </td>
      );
    });

    return (
      <tr key={index} style={{ textAlign: "center" }}>
        {columnData}
      </tr>
    );
  };

  const tableData = () => {
    return lotteryData.map((key, index) => tableRows({ key, index }));
  };

  const headRow = () => {
    return Object.values(tableHead).map((title, index) => (
      <th key={index}>
        <div className="m-auto minw-maxcontent">{title}</div>
      </th>
    ));
  };


  return (
    <Box sx={{ height: "auto", marginTop: "10px" }}>
      <Card style={cardStyle}>
        <CardContent sx={{ padding: { xs: "10px", md: "20px" } }}>
          <Grid container justifyContent={"space-between"}>
            <Grid
              item
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: "10px",
              }}
            >
              <Typography
                component="h4"
                sx={{
                  fontSize: {
                    xs: "14px !important",
                    md: "16px !important",
                    lg: "20px !important",
                  },
                }}
              >
                My Lottery
              </Typography>
            </Grid>
            <Grid
              item
              sx={{
                display: "flex",
                flexFlow: "column",
                gap: "5px",
                color: "#fff",
                fontSize: {
                  xs: "14px !important",
                  md: "16px !important",
                  lg: "20px !important",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <img
                  src={MervIcon}
                  className="log-merv-wallet"
                  style={{
                    height: "auto",
                    width: "22px",
                    position: "relative",
                  }}
                  alt=""
                />{" "}
                {coins?.data?.data}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <img
                  src={yellowt}
                  className="log-merv-wallet"
                  style={{
                    height: "auto",
                    width: "22px",
                    position: "relative",
                  }}
                  alt=""
                />
                <CurrencyFormat
                  value={dataWallet?.data?.walletAmount}
                  thousandSeparator={","}
                  displayType={"text"}
                  decimalSeparator={"."}
                />
              </Box>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box className="table-t1 sticky-table">
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  height: "100%",
                }}
              >
                {lotteryData.length > 0 && !isFetching && (
                  <thead>
                    <tr className="table-th" style={{ textAlign: "center" }}>
                      {headRow()}
                    </tr>
                  </thead>
                )}
                <tbody>
                  {isFetching ? (
                    <tr className="table-th2">
                      <td colSpan={9} style={{ height: "auto", textAlign: "center" }}>
                        <CircularProgress size={80} />
                      </td>
                    </tr>
                  ) : lotteryData.length === 0 ? (
                    <tr>
                      <td colSpan={9}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="400px"
                          textAlign="center"
                        >
                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            style={{ color: "#ff862d" }}
                          >
                            🎉 Every Lottery begins with a blank page <br />
                            ✨ Yours could be the one written in <strong>gold</strong>! 🏆
                          </Typography>
                        </Box>
                      </td>
                    </tr>
                  ) : (
                    <>{tableData()}</>
                  )}
                </tbody>

              </table>
            </Box>

          </Grid>
          {isFetching ? (
            <Box className="paginationBox">""</Box>
          ) : (
            <Box className="paginationBox">
              <Pagination
                pageSize={limit}
                onChange={handlePageChange}
                current={currentPage}
                total={totalItems}
              />
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

